import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { LkpExpenssesModel } from '../models/LkpExpenssesModel';
@Injectable({
  providedIn: 'root'
})
export class LkpExpenssesService {
  constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
  }

  public GetExpenses(expcode: string , compCode: string) {

    let params = new HttpParams();
      params = params.append("ExpCode", expcode);
      params = params.append("compCode", compCode);
      const options = {
        params: params
    };
    return this.http.get<LkpExpenssesModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpExpensses/GetLkpExpensses',options);
  }

  public AddExpenses(expenses: LkpExpenssesModel) {
    return this.http.post<LkpExpenssesModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpExpensses/AddLkpExpensses', expenses);
  }

  public DelExpenses(expcode: string , compCode: string) {

    let params = new HttpParams();
      params = params.append("ExpCode", expcode);
      params = params.append("compCode", compCode);
      const options = {
        params: params
    };
    return this.http.get<LkpExpenssesModel>(this.urlsconfig.WebAPIURL_Test + 'api/LkpExpensses/DeleteLkpExpensses',options);
  }

  public getExpenssesLookupTop(compCode: string) {

    let params = new HttpParams();
    params = params.append("compcode", compCode);
    const options = {
      params: params
    };

    return this.http.get<LkpExpenssesModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/LkpExpensses/ExpenssesLookupTop', options);
  }

}
